export const VIBRATION_STORAGE_KEY = "tasbeeh"

/** Default: on — short buzz on each tap when the device supports it. */
export function parseVibrationEnabled() {
 if (typeof localStorage === "undefined") return true
 try {
 const v = localStorage.getItem(VIBRATION_STORAGE_KEY)
 if (v === null) return true
 return v === "1" || v === "true"
 } catch {
 return true
 }
}

/** Web Vibration API — works on many Android browsers; not supported on iOS Safari. */
export function triggerTapVibration(enabled) {
 if (!enabled) return
 try {
 if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
 navigator.vibrate(15)
 }
 } catch {
// ignore
 }
}